import axios from 'axios';
import { getFunctionUrl } from '../config/api';
import { getAuth } from 'firebase/auth';
import { metricsCache } from './metricsCache';

// Create axios instance with configuration
const api = axios.create({
  timeout: 60000, // 60 second timeout for sync operations
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
api.interceptors.request.use(async (config) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  } catch (error) {
    
    return config;
  }
});

export const syncService = {
  async forceSync(): Promise<void> {
    try {
      // Trigger syncs in parallel
      await Promise.all([
        // Use Netlify function to trigger sync for Good Things
        api.post(getFunctionUrl('goodThings/sync/force'), {}, {
          timeout: 60000 // 1 minute timeout for sync
        }),
        
        // Use Netlify function to trigger sync for SOPs
        api.post(getFunctionUrl('sops/sync/force'), {}, {
          timeout: 60000 // 1 minute timeout for sync
        })
      ]);

      // Use Firebase Functions for other data types if needed
      // This could be expanded to include other data types in the future

      // Clear frontend caches
      metricsCache.clearAllCaches();
      
      // Clear SOP cache
      if (typeof window !== 'undefined') {
        localStorage.removeItem('sopCache');
        // Also use the sopCache service to clear memory cache
        const { sopCache } = await import('./sopCache');
        sopCache.clearCache();
      }
      
      
    } catch (error) {
      
      throw error;
    }
  }
};

export default syncService;
